module.exports = __webpack_public_path__ + "media/bundles/YoupiJob/assets/images/baby-sitting/child-age2-4bb224708180c38121c26543a074de8e.svg";